<template>
  <div class="flex flex-col min-h-screen">
    <header role="banner">
      <AppHeader ref="headerRef" @height-change="updateHeaderHeight" />
    </header>
    <AppSidebar
      v-if="userStore.isAuthenticated"
      :style="{ paddingTop: `${headerHeight}px` }"
    />
    <AppSidebarSkeleton
      v-else-if="userStore.isLoading"
      :style="{ paddingTop: `${headerHeight}px` }"
    />
    <main
      role="main"
      :style="{ paddingTop: `${headerHeight}px` }"
      class="grow relative"
    >
      <RouterView
        v-slot="{ Component, route }"
        :class="[
          // No sidebar padding if not authenticated and not loading
          !userStore.isAuthenticated && !userStore.isLoading ? '!pl-0' : '',
          // Skeleton sidebar is always expanded (80), real sidebar can be 16 or 80
          userStore.isLoading ? 'lg:pl-80' : (!sidebarIsExpanded ? 'lg:pl-16' : 'lg:pl-80'),
          'w-full',
        ]"
      >
        <Transition name="page-fade" mode="out-in">
          <div :key="route.name">
            <Component :is="Component" />
          </div>
        </Transition>
        <ModalUnsavedChanges />
      </RouterView>
    </main>
    <footer role="contentinfo">
      <AppFooter />
      <AppToastContainer />
    </footer>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import { storeToRefs } from 'pinia'

import AppToastContainer from '../components/layout/toast/AppToastContainer.vue'
import AppHeader from '../components/layout/header/AppHeader.vue'
import AppSidebar from '../components/layout/sidebar/AppSidebar.vue'
import AppSidebarSkeleton from '../components/layout/sidebar/AppSidebarSkeleton.vue'
import AppFooter from '../components/layout/footer/AppFooter.vue'
import ModalUnsavedChanges from '../components/modal/ModalUnsavedChanges.vue'
import { useSidebarStore } from '../stores/sidebarStore.js'
import { useUserStore } from '../stores/userStore.js'

const sidebarStore = useSidebarStore()
const userStore = useUserStore()

const { sidebarIsExpanded } = storeToRefs(sidebarStore)

const headerRef = ref(null)
const headerHeight = ref(0)

const updateHeaderHeight = async () => {
  if (headerRef.value) {
    await nextTick()
    headerHeight.value = headerRef.value.$el.offsetHeight
  }
}
</script>

<style scoped>
/* Page transition - faster fade for all route changes */
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.15s ease;
}

.page-fade-enter-from,
.page-fade-leave-to {
  opacity: 0;
}
</style>
